export const actionsBeforeDocCreate = (params: any): any => {
  delete params['pagamento_stato'];
  delete params['pagamento_importo_da_saldare'];
  delete params['pagamento_importo_saldato'];
  delete params['ritenuta_importo'];
  delete params['enasarco_importo'];
  delete params['totale_documento_netto'];
  delete params['totale_documento_ivato'];
  delete params['totale_documento_iva_importo'];
  delete params['casse_numero'];
  delete params['casse_importo'];
  delete params['pagamento_scadenze_incongruenti'];
  delete params['invio_stato_data'];
  delete params['extra_info'];
  delete params['riepiloghi_lista'];
  delete params['autofattura_riferimento'];
  if (params['fe_api']) {
    delete params['fe_api']['sdi_id'];
    Object.keys(params['fe_api']).length === 0 && delete params['fe_api'];
  }
  return params;
};
